import { render, staticRenderFns } from "./TableCampaign.vue?vue&type=template&id=2807835e"
import script from "./TableCampaign.vue?vue&type=script&lang=js"
export * from "./TableCampaign.vue?vue&type=script&lang=js"
import style0 from "./TableCampaign.vue?vue&type=style&index=0&id=2807835e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports